import type { MessageKey } from "./ru"

export const jaMessages = {
  "common.loading": "読み込み中...",
  "common.error": "エラー",
  "common.back": "戻る",
  "common.next": "次へ",
  "common.search": "検索",
  "auth.loginErrorTitle": "ログインエラー",
  "auth.openViaTelegram": "Telegramからアプリを開いてください",
  "auth.telegramRequired": "このアプリはTelegramから開く必要があります",
  "auth.authorizationError": "認証エラー",
  "device.rotatePortrait": "端末を縦向きにしてください",
  "country.brazil": "ブラジル",
  "country.vietnam": "ベトナム",
  "country.egypt": "エジプト",
  "country.india": "インド",
  "country.indonesia": "インドネシア",
  "country.iran": "イラン",
  "country.spain": "スペイン",
  "country.italy": "イタリア",
  "country.kazakhstan": "カザフスタン",
  "country.colombia": "コロンビア",
  "country.malaysia": "マレーシア",
  "country.mexico": "メキシコ",
  "country.nigeria": "ナイジェリア",
  "country.pakistan": "パキスタン",
  "country.russia": "ロシア",
  "country.usa": "アメリカ合衆国",
  "country.turkey": "トルコ",
  "country.uzbekistan": "ウズベキスタン",
  "country.ukraine": "ウクライナ",
  "country.philippines": "フィリピン",
  "countrySelection.chooseCountry": "国を選択",
  "countrySelection.openAria": "国を選択",
  "languageSelection.chooseLanguage": "言語を選択",
  "commercial.direction.autotrade": "オートマーケット",
  "commercial.direction.insurance": "保険",
  "commercial.direction.pitstop": "ピットストップ",
  "commercial.direction.techhelp": "ロードサービス",
  "commercial.searchLabel": "BeepApp検索",
  "commercial.cityPlaceholder": "都市を入力",
  "commercial.emptyTitle": "本日のオファーはありません",
  "commercial.emptyLine1": "あなたの都市にはまだBeepAppの提携先がありません",
  "commercial.emptyLine2": "現在、提携先の検索と接続を進めています",
  "commercial.emptyLine3": "新しいオファーはここに自動表示されます",
  "commercial.helperLine1": "都市を入力すると",
  "commercial.helperLine2": "利用可能なオファーを確認できます",
  "commercial.partnerPrompt": "BeepAppのパートナーになりませんか？",
  "commercial.apply": "申し込む",
  "main.admin": "管理",
  "main.garage": "ガレージ",
  "main.signalSent": "シグナルを送信しました",
  "main.partnerInviteUnavailable": "パートナー招待は利用できません",
  "main.enterPlate": "ナンバープレートを入力",
  "main.searchError": "検索エラー",
  "main.signalSendError": "シグナルを送信できませんでした",
  "main.shareCardPrefix": "ナンバーカード",
  "main.shareLinkError": "リンクを作成できませんでした",
  "main.searchByPlateAria": "ナンバープレートで検索",
  "main.russianPlateAria": "ロシアのナンバープレート",
  "main.plateAria": "ナンバープレート",
  "main.findPlateAria": "ナンバーを検索",
  "main.loadingVehicle": "車両カードを読み込み中…",
  "main.leaveSignal": "シグナルを送る",
  "main.share": "共有",
  "signalSelection.chooseType": "シグナルの種類を選択",
  "signalSelection.category.attention": "パーソナル",
  "signalSelection.category.road": "道路",
  "signalSelection.category.urgent": "緊急",
  "signalSelection.chooseSignal": "シグナルを選択",
  "signalSelection.suggestOwn": "別の案を提案",
  "signalConfirmation.title": "シグナルを確認",
  "signalConfirmation.plateHeading": "ナンバープレートを確認",
  "signalConfirmation.signalHeading": "選択したシグナルを確認",
  "signalConfirmation.replyTitle": "Telegramでの返信を許可",
  "signalConfirmation.replyBody": "有効にすると、ナンバーの所有者がTelegramで\nあなたにメッセージを送れます。返信には\n@usernameが必要です。返信するかどうかは\nナンバーの所有者が判断します。",
  "signalConfirmation.consentText": "このシグナルが実際の状況に基づき、\nスパムや虚偽の報告ではないことを\n確認します。",
  "signalConfirmation.warning": "送信後はシグナルを\n変更できません",
  "signalConfirmation.sending": "送信中…",
  "signalConfirmation.send": "送信",
  "partner.loadingAria": "読み込み中",
  "partner.title": "パートナープログラム",
  "partner.offerLine1": "招待したユーザーのすべての支払いから30%を獲得",
  "partner.offerLine2": "BeepAppへ招待したユーザーが対象です",
  "partner.offerLine3": "Telegramアフィリエイトプログラムを利用します",
  "partner.connectUnavailable": "Telegramアフィリエイトプログラムの設定後に接続できるようになります。",
  "partner.connectTelegram": "Telegramで接続",
  "partner.qrAria": "パートナーリンクのQRコード",
  "partner.download": "ダウンロード",
  "partner.promoHeading": "個人用プロモコードを作成",
  "partner.promoHelperLine1": "プロモコードで追加の1年契約が有効になります",
  "partner.promoHelperLine2": "ユーザー獲得にも役立ちます",
  "partner.promoAria": "プロモコード",
  "partner.affiliateHeading": "あなたのアフィリエイトリンク",
  "partner.affiliateHelper": "リンクを保存して個人用QRコードを作成します",
  "partner.affiliateAria": "アフィリエイトリンク",
  "partner.qrNoteLine1": "QRコードは車両や、",
  "partner.qrNoteLine2": "SNS、広告素材に掲載できます",
  "partner.save": "保存",
  "partner.reset": "リセット",
  "partner.resetConfirm": "保存したアフィリエイトリンクをリセットしますか？プロモコードは維持されます。",
  "partner.promoFormatError": "プロモコードは4〜15文字で入力してください。",
  "partner.affiliateHostError": "t.me または telegram.me のリンクのみ使用できます。",
  "partner.affiliatePathError": "リンクにTelegramのパスが含まれていません。",
  "partner.affiliateFormatError": "アフィリエイトリンクが無効です。",
  "partner.loadError": "読み込みエラー",
  "partner.checkInputError": "入力内容を確認してください",
  "garageActivation.promoInvalid": "プロモコードが無効です",
  "garageActivation.plateOccupied": "このナンバーはすでに連携されています",
  "garageActivation.activateError": "ガレージを有効化できませんでした",
  "garageEntry.loadJournalError": "ログブックを読み込めませんでした",
  "garageEntry.loadStatusesError": "ステータスを読み込めませんでした",
  "garageEntry.activationSuccess": "ガレージを有効化しました",
  "garageEntry.plateAttached": "ナンバーを連携しました",
  "garageEntry.attachError": "ナンバーを連携できませんでした",
  "garageEntry.activationNote": "ガレージを有効化してください",
  "garageSheet.activationTitle": "ガレージの有効化",
  "garageSheet.plateHelper": "車両のナンバープレートを入力",
  "garageSheet.promoHelper": "プロモコードをお持ちですか？",
  "garageSheet.cleanBonusLine1": "有効化後1時間以内は",
  "garageSheet.cleanBonusLine2": "「Clean Start」を無料で利用できます",
  "garageSheet.activationFor": "有効期間",
  "garageSheet.cost": "料金",
  "garageSheet.ownerConsentLine1": "入力したナンバープレートの",
  "garageSheet.ownerConsentLine2": "車両の所有者であることを",
  "garageSheet.ownerConsentLine3": "確認します。",
  "garageSheet.processing": "処理中...",
  "garageSheet.attach": "連携",
  "garageSheet.pay": "支払う",
  "garageLifecycle.cleanTitle": "Clean Start",
  "garageLifecycle.deactivateTitle": "ガレージの無効化",
  "garageLifecycle.cleanWarningLine1": "ナンバーの履歴は削除され、",
  "garageLifecycle.cleanWarningLine2": "復元できません！",
  "garageLifecycle.deactivateWarningLine1": "無効化すると、ガレージの",
  "garageLifecycle.deactivateWarningLine2": "有効な機能を利用できなくなります",
  "garageLifecycle.willBeDeleted": "削除されます",
  "garageLifecycle.cleanRemovedLine1": "• ログブックのすべての記録",
  "garageLifecycle.cleanRemovedLine2": "• 受信したシグナルの履歴",
  "garageLifecycle.cleanRemovedLine3": "• 公開シグナルカウンター",
  "garageLifecycle.cleanRemovedLine4": "  ナンバーカード上の表示",
  "garageLifecycle.willRemain": "保持されます",
  "garageLifecycle.cleanPreservedLine1": "• ナンバーとガレージの連携",
  "garageLifecycle.cleanPreservedLine2": "• 残りの有効期間",
  "garageLifecycle.cleanPreservedLine3": "• 選択したナンバーステータス",
  "garageLifecycle.cleanPreservedLine4": "• ナンバーカードの総閲覧数",
  "garageLifecycle.freeFirstHour": "最初の1時間は無料",
  "garageLifecycle.willBecomeUnavailable": "利用できなくなります",
  "garageLifecycle.deactivateRemovedLine1": "• ログブック",
  "garageLifecycle.deactivateRemovedLine2": "• ナンバーステータスの選択と利用",
  "garageLifecycle.deactivateRemovedLine3": "• AutoClanから自動的に退出",
  "garageLifecycle.deactivateRemovedLine4": "• オートマーケット",
  "garageLifecycle.deactivateRemovedLine5": "• 保険",
  "garageLifecycle.deactivateRemovedLine6": "• ピットストップ",
  "garageLifecycle.deactivateRemovedLine7": "• ロードサービス",
  "garageLifecycle.deactivateRemovedLine8": "• ナンバーとガレージの連携解除",
  "garageLifecycle.willRemainAvailable": "引き続き利用できます",
  "garageLifecycle.deactivatePreservedLine1": "• コンパニオン",
  "garageLifecycle.deactivatePreservedLine2": "• ディスパッチャー",
  "garageLifecycle.deactivatePreservedLine3": "• ナンバー検索と閲覧",
  "garageLifecycle.deactivatePreservedLine4": "  公開車両カード",
  "garageLifecycle.deactivatePreservedLine5": "• いつでもガレージを",
  "garageLifecycle.deactivatePreservedLine6": "  再有効化できます",
  "garageLifecycle.cleanConsentLine1": "このナンバーの全履歴を",
  "garageLifecycle.cleanConsentLine2": "復元できない形で削除することに",
  "garageLifecycle.cleanConsentLine3": "同意します。",
  "garageLifecycle.deactivateConsentLine1": "無効化し、ガレージの",
  "garageLifecycle.deactivateConsentLine2": "すべての有効な機能へのアクセスを",
  "garageLifecycle.deactivateConsentLine3": "終了することを確認します。",
  "garageLifecycle.clean": "消去",
  "garageLifecycle.deactivate": "無効化",
} satisfies Record<MessageKey, string>
